import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum QualityManagementTeacherListFields {
    FOR_STATES = 'forStates',
    CREATOR = 'creator',
    ASSIGNEE = 'assignee',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace QualityManagementTeacherListFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<QualityManagementTeacherListFields, Data> = {
        [QualityManagementTeacherListFields.FOR_STATES]: {
            text: 'Bundesländer',
        },
        [QualityManagementTeacherListFields.CREATOR]: {
            text: 'Ersteller:in',
            readOnly: true,
        },
        [QualityManagementTeacherListFields.ASSIGNEE]: {
            text: 'QM-Zuständige:r',
        },
        [QualityManagementTeacherListFields.CREATED_AT]: {
            text: 'Erstellt am',
            readOnly: true,
        },
        [QualityManagementTeacherListFields.UPDATED_AT]: {
            text: 'Zuletzt bearbeitet am',
            readOnly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
